import styled, { css } from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { BREAKPOINTS } from '~/src/components/BlockInternet/constants';

import { breakePoints } from '~/src/features/internet/internet-represent/styled';

type TImgBlock = {
    imgUrl?: string,
    hasImgStyle?: {
        tablet?: boolean,
        mobile?: boolean,
    },
}

export const FastInternetContainer = styled.div`
    width: 100%;
    box-sizing: content-box;
    margin: 32px 0;
`;

export const FastInternetTitle = styled.h2`
    color: ${COLORS.GRAY_DARK};
    ${FONTS.H2};

    @media (max-width: ${breakePoints.desktop}) {
        ${FONTS.H3};
    }

    @media (max-width: ${breakePoints.mobile}) {
        ${FONTS.H4};
    }
`;

export const FastInternetBlock = styled.div`
    display: grid;
    width: 100%;
    margin-top: 32px;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 32px;

    @media (max-width: 950px) {
        grid-gap: 16px;
     }

    @media (max-width: ${BREAKPOINTS.mobile}) {
        display: flex;
    }
`;

export const ImgBlock = styled.div<TImgBlock>`
    border-radius: 16px;
    ${(props) => props.imgUrl && css`
    background-image: url('${props.imgUrl}');
    background-repeat: no-repeat;
    background-position: left;
    background-size: contain;
    width: 211px;
    height: 96px;

    @media (max-width: ${BREAKPOINTS.tablet}) {
       margin-top: 15%;
    }

    @media (max-width: 900px) {
        margin: 0;
        width: 190px;
     }

    @media (max-width: ${BREAKPOINTS.mobile}) {
        background-position: center;
    }
`};
`;

export const TextBlock = styled.div`
    @media (max-width: ${BREAKPOINTS.mobile}) {
        justify-content: flex-start;
    }
`;

export const ContentWrap = styled.div`
    flex-direction: column;
    gap: 0;
    height: auto;
    background: ${COLORS.white};
    border: 0.5px solid ${COLORS.GRAY_XS};
    border-radius: ${BorderRadius.OuterBlockRadius};
    padding: 14px 24px;

    @media (max-width: 835px) {
        padding: 27px 17px 17px;
    }

    @media (max-width: ${BREAKPOINTS.mobile}) {
        align-items: center;
        justify-content: center;
        padding: 14px 24px;
    }
`;

export const Title = styled.div`
    margin: 8px 0px;
    ${FONTS.H4};
    color: ${COLORS.GRAY_DARK};
    @media (max-width: ${BREAKPOINTS.tablet}) {
        ${FONTS.H5};
    }
`;

export const SubText = styled.div`
    ${FONTS.XS};
    color: ${COLORS.GRAY_DARK};
`;
